import { BORDER_RADIUS } from '../consts/border-radius';
export var CSS_BORDER_RADIUS = {
  SMALL: "border-radius: " + BORDER_RADIUS.SMALL + ";",
  MEDIUM: "border-radius: " + BORDER_RADIUS.MEDIUM + ";",
  LARGE: "border-radius: " + BORDER_RADIUS.LARGE + ";"
};
//# sourceMappingURL=border-radius.js.map